export const initGetFeedbackScript = (userEmail) => {        
    const bizzaboEmailSuffix = '@bizzabo.com';    
    const selectedScriptFileName = userEmail?.endsWith(bizzaboEmailSuffix) ? 'getfeedbackBizzaboersScript' : 'getfeedbackGeneralScript';
    return import(`./${selectedScriptFileName}`);    
}